import Grid from '@material-ui/core/Grid'
import { Show, TopToolbar, usePermissions } from 'react-admin'

import { AutoBidInfo } from 'components/Common/AutoBidInfo'
import { postRequest } from '../../api/common'
import { markAsNotInterested } from '../../api/contactedLoads'
import { ContactedLoadStatus } from '../../helpers/constants'
import { hasPermission, Permissions } from '../../Permissions'
import { BaseActionDetailButton } from '../Common/ActionButtons'
import { BookContactedLoadButton, LoadShowLayout } from '../Common/Loads'
import { LabeledTypographyField } from '../Fields'

const ContactedLoadShowActions = ({ basePath, data }: any) => {
  const { permissions } = usePermissions()
  if (!data || !permissions) return null
  const canCreateJob = hasPermission(permissions, Permissions.AddJob)
  const isOpen = [ContactedLoadStatus.Contacted, ContactedLoadStatus.Autobid].includes(data.status)
  const notInterestedTitle = 'Mark Not Interested'
  const notInterestedBody =
    'This contacted load will be closed out & marked as not interested for the driver.'

  return (
    <TopToolbar>
      <Grid container direction="column" spacing={2}>
        <Grid item container direction="row" spacing={6} justifyContent="flex-start" alignItems="center">
          <Grid item>
            <LabeledTypographyField variant="body1" label="Contacted Load Status" value={data.status} />
          </Grid>
          <Grid item>
            <LabeledTypographyField
              variant="body1"
              label="Created by"
              value={`${data.created_by.first_name} ${data.created_by.last_name}`}
            />
          </Grid>
          {data.status !== ContactedLoadStatus.Autobid && (
            <Grid item>
              <LabeledTypographyField variant="body1" label="Reminder count" value={data.reminder_count} />
            </Grid>
          )}
        </Grid>
        {canCreateJob && isOpen && (
          <Grid container item direction="row" spacing={2} justifyContent="flex-start" alignItems="center">
            {data.status === ContactedLoadStatus.Autobid && (
              <Grid item>
                <BaseActionDetailButton
                  record={data}
                  actionRequest={(id) =>
                    postRequest('/api/v3/autobid/cancel-negotiation/', { contacted_load_id: id })
                  }
                  actionTitle="Cancel Bid"
                  actionText="If you cancel this bid, this load will be removed from the contacted load list for both you and the user."
                />
              </Grid>
            )}
            <Grid item>
              <BookContactedLoadButton record={data} basePath={basePath} />
            </Grid>
            <Grid item>
              <BaseActionDetailButton
                record={data}
                actionRequest={markAsNotInterested}
                actionTitle={notInterestedTitle}
                actionText={notInterestedBody}
              />
            </Grid>
          </Grid>
        )}
      </Grid>
      {data?.bid_history && data?.bid_history.length > 0 && (
        <Grid container direction="column" spacing={2}>
          <Grid item>
            <AutoBidInfo
              bidMinimum={data?.bid_minimum}
              bidMaximum={data?.bid_maximum}
              history={data?.bid_history}
            />
          </Grid>
        </Grid>
      )}
    </TopToolbar>
  )
}

const ContactedLoadShow = (props: any) => (
  <Show actions={<ContactedLoadShowActions />} {...props}>
    <LoadShowLayout isContactedLoad={true} />
  </Show>
)

export default ContactedLoadShow
